import React from "react";
import '../screens/styles/AboutUs.css';
import styles from '../styles/aboutme.module.scss';
import rec from '../assets/image/rec.jpg'
import berat from '../assets/image/berat.jpeg';

function AboutUs() {
    return (
        <div className={styles.main}>
            {/* <div className={styles.container1}>
                <img className={styles.picAboutUs1} src={berat} alt="test" />
                <div>
                    <div className={styles.info1}>
                        <p className={styles.textTitleAboutUs1}>Berat Duymaz</p>
                        <p className={styles.textAboutUs1}>
                            I have worked as a Digital Marketing and Social Media Manager in corporate
                            companies since 2016. Recently, I continue my carrier as a freelancer of some
                            companies’ YouTube, SEO and Facebook advertising activities related with the
                            trainings I had from Google and Boğaziçi Institution in 2021.</p>
                            <p className={styles.textAboutUs1}>Contact: bdberatduymaz@gmail.com</p>
                    </div>
                </div>
            </div> */}
            <div className={styles.container2}>
                <img className={styles.picAboutUs2} src={rec} alt="test" />
                <div>
                <div className={styles.info2}>
                    <p className={styles.textTitleAboutUs2}>Resul Ekrem Çoban</p>
                    <p className={styles.textAboutUs2}>
                        I graduated from computer engineering in 2013 and finished master degree about 
                        information technologies from Galatasaray University.
                        In addition, I have been working as a software developer since 2014. 
                        My professional field is react-native. I had been working as an Android developer before, 
                        but I have been typing code since 2018 with react-native.</p>
                    <p className={styles.textAboutUs2}>Contact: resulekremcoban@gmail.com</p>
                </div>
                </div>
            </div>
            {/* <div className="frameAboutUs">
                <img className='picAboutUs' src={rec} alt="test" />
                <div>
                    <p className="textTitleAboutUs">Resul Ekrem Çoban</p>
                    <p className="textAboutUs">
                        I graduated from computer engineering in 2013 and finished master degree about 
                        information technologies from Galatasaray University.
                        In addition, I have been working as a software developer since 2014. 
                        My professional field is react-native. I had been working as an Android developer before, 
                        but I have been typing code since 2018 with react-native.</p>
                    <p className="textAboutUs">resulekremcoban@gmail.com</p>
                </div>
            </div> */}
        </div>
    )
}

export default AboutUs